"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CommonBaseError_1 = require("../../Common/CommonBaseError");
exports.CommandHubErrorName = "CommandHubError";
class CommandHubError extends CommonBaseError_1.CommonBaseError {
}
exports.CommandHubError = CommandHubError;
//# sourceMappingURL=IRtcCommandHub.js.map